import type {DefaultOptions} from '../../../types';
import type {
    TextWithMetadataValueEditorLocalizations,
    TextWithMetadataValueEditorModel,
    TextWithMetadataValueEditorOptions
} from './types';

export const TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<TextWithMetadataValueEditorOptions> = {
    customEmptyAsNullCheck: ({value}: { value: TextWithMetadataValueEditorModel }) => (value?.row ?? '').length === 0,
    excludedExtensions: []
};

export const TEXT_WITH_METADATA_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<TextWithMetadataValueEditorLocalizations>({
    startsWith: 'starts with',
    wholeStartsWith: 'whole starts with',
    equals: 'exact match',
    equalsWords: 'equals words',
    metadataSelectLabel: '',
    currentSelectValue: 'Currently selected value',
    mainInputLabel: '',
    description: ''
});